







































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import KepatuhanJatuhStore from "@/store/modules/KepatuhanJatuhStore";
import { userModule } from "@/store/modules/user";
import { storePerawat } from "@/store/modules/perawat";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";

@Component({
  components: { UnitRuangPicker, PersonAutoComplete }
})
export default class SetupSesiStep extends Vue {
  @Prop({ default: null }) session!: any;
  valid = false;
  saving = false;
  error = "";

  form: any = this.initialForm();

  required = (v: any) => (v !== null && v !== undefined && v !== "") || "Wajib diisi";
  periodeOpts = [
    { text: "Harian", value: "harian" },
    { text: "Bulanan", value: "bulanan" },
    { text: "Triwulanan", value: "triwulanan" },
    { text: "Semester", value: "semester" },
    { text: "Sewaktu", value: "sewaktu" }
  ];
  bulanOpts = [
    { text: "Januari", value: 1 },
    { text: "Februari", value: 2 },
    { text: "Maret", value: 3 },
    { text: "April", value: 4 },
    { text: "Mei", value: 5 },
    { text: "Juni", value: 6 },
    { text: "Juli", value: 7 },
    { text: "Agustus", value: 8 },
    { text: "September", value: 9 },
    { text: "Oktober", value: 10 },
    { text: "November", value: 11 },
    { text: "Desember", value: 12 }
  ];
  shiftOpts = [
    { text: "Pagi", value: "pagi" },
    { text: "Siang", value: "siang" },
    { text: "Malam", value: "malam" },
    { text: "Lintas Shift", value: "lintas_shift" }
  ];

  get store() {
    return KepatuhanJatuhStore;
  }

  get currentUser() {
    return userModule && userModule.user ? userModule.user : null;
  }

  get tahunOpts() {
    const now = new Date().getFullYear();
    return [now, now - 1, now - 2];
  }

  initialForm() {
    const now = new Date();
    return {
      periode_observasi: "harian",
      periode_tahun: now.getFullYear(),
      periode_bulan: now.getMonth() + 1,
      periode_triwulan: null,
      periode_semester: null,
      tanggal_observasi: localISODate(now),
      unit_id: null,
      unit_nama: "",
      ruang_detail: "",
      shift_observasi: null,
      observer_id: null,
      observer_nama: "",
      catatan_umum: ""
    };
  }

  @Watch("session", { immediate: true, deep: true })
  onSession(v: any) {
    if (v && v.id) {
      // Edit existing — hydrate form
      this.form = {
        ...this.initialForm(),
        ...v,
        unit_id: v.unit_id !== null && v.unit_id !== undefined ? String(v.unit_id) : null,
        observer_id:
          v.observer_id !== null && v.observer_id !== undefined
            ? Number(v.observer_id)
            : null
      };
    }
  }

  mounted() {
    if (!this.session || !this.session.id) {
      const u = this.currentUser;
      if (u && u.id) {
        this.form.observer_id = u.id;
        this.form.observer_nama = u.nama || "";
      }
    }
  }

  onUnitChange(unit: any) {
    this.form.unit_nama = unit && unit.nama ? unit.nama : "";
  }

  onObserverChange(id: any) {
    this.form.observer_id = id || null;
    if (!id) {
      this.form.observer_nama = "";
      return;
    }
    const found = storePerawat.listKaryawan.find(
      (k: any) => Number(k.id) === Number(id)
    );
    if (found) this.form.observer_nama = found.nama;
  }

  async save() {
    this.error = "";
    this.saving = true;
    try {
      if (this.session && this.session.id) {
        await this.store.update({ id: this.session.id, data: this.form });
      } else {
        await this.store.create(this.form);
      }
      this.$emit("saved");
    } catch (e) {
      this.error =
        e.response?.data?.message || e.message || "Gagal menyimpan sesi";
    } finally {
      this.saving = false;
    }
  }
}
